module.exports = __webpack_public_path__ + "static/media/Ellipse.2ec60c3f.png";